import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { EmailsBlacklistService } from '../emails-blacklist.service';
import { AddEmailBlacklist } from '../emails-blacklist.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-add-emails-blacklist',
    templateUrl: './add-emails-blacklist.component.html',
    styleUrls: ['./add-emails-blacklist.component.scss']
})
export class AddEmailsBlacklistComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    statusOptions: { name: string; id: number }[] = [
        // { name: '--Alegeți--', id: -1, },
        { name: 'DA', id: 1 },
        { name: 'NU', id: 0, }
    ];

    form: FormGroup = new FormGroup({
        email: new FormControl('', [
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
        ]),
        process: new FormControl(0, [Validators.required]),
        confirmation: new FormControl(0, [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { email?: string } | null,
        private dialogRef: MatDialogRef<AddEmailsBlacklistComponent>,
        private requestService: EmailsBlacklistService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit() {
        if (this.data && this.data.email) {
            this.form.patchValue({
                email: this.data.email
            });
        }
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;


        const { email, process, confirmation } = this.form.value;
        const payload: AddEmailBlacklist = {
            email, process, confirmation
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
